import { CaseStatus } from '@/api/caseSearch';
import { ROUTES } from '@/router';

export function enabledActionsByStatus(status: CaseStatus): ROUTES[] {
    const actions: Record<CaseStatus, ROUTES[]> = {
        [CaseStatus.Created]: [ROUTES.EDIT_CASE],
        [CaseStatus.GeneratingDicoms]: [ROUTES.EDIT_CASE],
        [CaseStatus.ImageSegmentation]: [ROUTES.EDIT_CASE, ROUTES.DICOMS],
        [CaseStatus.SurgicalTemplating]: [ROUTES.EDIT_CASE, ROUTES.DICOMS],
        [CaseStatus.GeneratingPlan]: [ROUTES.EDIT_CASE, ROUTES.DICOMS, ROUTES.PLANNER,],
        [CaseStatus.Completed]: [
            ROUTES.EDIT_CASE,
            ROUTES.DICOMS,
            ROUTES.PLANNER,
            ROUTES.PLANS,
        ],
        [CaseStatus.Warning]: [ROUTES.EDIT_CASE, ROUTES.DICOMS, ROUTES.PLANNER],
        [CaseStatus.Error]: [ROUTES.EDIT_CASE],
    };

    const result = actions[status];
    if (result !== undefined) {
        return result;
    } else {
        throw new Error(`Invalid : ${status}`);
    }
}
